export default __webpack_public_path__ + "static/media/onePersonIcon.7ff5cb16.svg";